<mat-paginator
    [length]="totalCount"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 25, 50, 100]"
    aria-label="Select page of block items"
    (page)="onPage($event)"
>
</mat-paginator>
<table mat-table [dataSource]="productHistory">
    <ng-container matColumnDef="validFrom">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let row">
            {{ row.validFrom | date: "yyyy-MM-dd HH:mm:ss" : "utc" }}
        </td>
    </ng-container>

    <ng-container matColumnDef="providerId">
        <th mat-header-cell *matHeaderCellDef>ProviderId</th>
        <td mat-cell *matCellDef="let row">{{ row.providerId }}</td>
    </ng-container>

    <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>Price</th>
        <td mat-cell *matCellDef="let row">{{ row.price?.formatted }}</td>
    </ng-container>

    <ng-container matColumnDef="overridePriceAmount">
        <th mat-header-cell *matHeaderCellDef>Override Price</th>
        <td mat-cell *matCellDef="let row">{{ row.overridePriceAmount }}</td>
    </ng-container>

    <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef>Cost</th>
        <td mat-cell *matCellDef="let row">{{ row.cost?.formatted }}</td>
    </ng-container>

    <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>Value</th>
        <td mat-cell *matCellDef="let row">{{ row.value?.formatted }}</td>
    </ng-container>

    <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let row">{{ row.title }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
    </ng-container>

    <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef>Enabled</th>
        <td mat-cell *matCellDef="let row">{{ row.enabled }}</td>
    </ng-container>

    <ng-container matColumnDef="providerRemoved">
        <th mat-header-cell *matHeaderCellDef>ProviderRemoved</th>
        <td mat-cell *matCellDef="let row">{{ row.providerRemoved }}</td>
    </ng-container>
    <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef>Note</th>
        <td mat-cell *matCellDef="let row">{{ row.note }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
